import React, { useEffect, useState, useRef } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import { useLoading, Rings } from "@agney/react-loading";
import AudienceFilters from "./AudienceFilters";
import { putSaveAudienceData, postSaveAudienceData, postPreviewAudienceData ,getFullAudience } from "api/AudienceApi";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  setAudienceName,
  setAudienceDescription,
  setEditAudience
} from "ReduxStore/Slices/audienceSlice";
import { getAudieceFilteredData } from "helperFuntion/getAudienceFilter";
import { validateAudienceConditions } from "helperFuntion/validateAudienceFilter";
import SupportLink from "../Common/SupportLink";
import $  from "jquery"
import './styles.css'

let PPreview = false;
function CreateCampaign(props) {
  const [isPreview, setIsPreview] = useState(false);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true)
  const [createAudiencePermission, setCreateAudiencePermission] = useState(false)
  const [permissionMessage, setPermissionMessage] = useState(null)

  const [editAudienceFilters, setEditAudienceFilters] = useState(null)
  const [editId, setEdit] = useState(null)



  const { audienceFilters, audienceName, audienceDescription } = useSelector(
    (state) => state.audienceSetter
  );



  const audienceNameRef = useRef();
  const audiencedescriptionRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    audienceNameRef.current.value = audienceName;
    audiencedescriptionRef.current.value = audienceDescription;

  }, [audienceName, audienceDescription]);

  useEffect(() => {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var audienceId = url.searchParams.get("id");

    if(audienceId){
      getFullAudience(audienceId).then((audience) => {
        console.log(audience);
        setEdit(audience.id)
        dispatch(setAudienceName(audience.name));
        dispatch(setAudienceDescription(audience.description));
        dispatch(setEditAudience(audience.id))	


        setEditAudienceFilters(audience.filters)
      })

    }else{
      setEdit(null)
      dispatch(setEditAudience(false));

    }
  },[])

  const submitCreateAudienceForm = (e) => {
    e.preventDefault();

    const filteredData = getAudieceFilteredData(audienceFilters);

    // 
    var saveData = {
      name: audienceName,
      description: audienceDescription,
      type: "Dynamic",
      filters: filteredData,
    };

   if (PPreview || isPreview) {
    props.history.push({
      pathname: "/admin/contact/audience/preview",
      data: saveData,
    });
  }
   else if (validateAudienceConditions(filteredData)) {
      if(editAudienceFilters){
        
        putSaveAudienceData(saveData, editId)
          .then((data) => {
            toast.success("Audience has been Saved successfully.");
            sessionStorage.removeItem("KW_Previous_AUD");
            props.history.push({
              pathname: "/admin/contact/audience/details",
            });
          })
          .catch((e) => { });


      }
    else {
        postSaveAudienceData(saveData)
          .then((data) => {
            toast.success("Audience has been created successfully.");
            sessionStorage.removeItem("KW_Previous_AUD");
            props.history.push({
              pathname: "/admin/contact/audience/details",
            });
          })
          .catch((e) => { });
      }
    } else {
      toast.error("Please fill all the required fields.");
    }

  };

  const messageBar = (permissionMessage) => {
    if (permissionMessage) {
      return (
        showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>

          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }

  return (
    <div>
      {
        <div>
          {
            messageBar(permissionMessage)
          }
          <SupportLink link='https://kapitalwise.com/user-guide/audience/' />

          <div className="new_header"> 
          <div className="page_heading" style={{padding:"20px"}}>
            <h2>Create Audience</h2>
            <p className="glo-desc"> Specific group of individuals or entities for whom a particular financial product is designed or targeted. </p>

          </div>
          </div>
          <form onSubmit={submitCreateAudienceForm}>
            <div className="audieneOuter">
              <div className="inputOuter">
                <label className="large">Audience Name</label>
                <input
                  id="audienceName"
                  onChange={(e) => dispatch(setAudienceName(e.target.value))}
                  type="text"
                  className="kwDesign max351"
                  required
                  ref={audienceNameRef}
                  placeholder="Enter Audience Name"
                />
              </div>
              <div className="inputOuter">
                <label className="large">Description</label>
                <textarea
                  id="textArea"
                  onChange={(e) =>
                    dispatch(setAudienceDescription(e.target.value))
                  }
                  placeholder="Enter Audience Description"
                  className="csTextarea"
                  required
                  ref={audiencedescriptionRef}
                />
              </div>
              {/* new filters start */}
              <AudienceFilters edit ={editId} editFilters = {editAudienceFilters} setCreateAudiencePermission={setCreateAudiencePermission} setPermissionMessage={setPermissionMessage} setShowPermissionMessage={setShowPermissionMessage} />

              <div className="new_footer" >
                <input
                  id = 'previewAudience'
                  type="submit"
                  name="Preview"
                  onClick={(e) =>
                    {PPreview =true; setIsPreview(true)}}
                  style={createAudiencePermission ? { margin: "2vh", cursor: "pointer", opacity: 0.5 } : { margin: "2vh", cursor: "pointer", opacity: 1 }}
                  className="lg_btn primary"
                  value="Preview Audience"
                  disabled={createAudiencePermission}
                />
                <input
                id='saveAudience'
                  type="submit"
                  name="Save"
                  onClick={(e) =>{
                    PPreview =false;
  
                      setIsPreview(false)
                    
                  } }
                  style={createAudiencePermission ? { margin: "2vh", cursor: "pointer", opacity: 0.5 } : { margin: "2vh", cursor: "pointer", opacity: 1 }}
                  className="lg_btn tertiary "
                  value="Save Audience"
                  disabled={createAudiencePermission}
                />

                {editId &&
                    <input
                    id='Cancelksk'
                      type="submit"
                      name="Save"
                      onClick={(e) =>{
                        props.history.push({  pathname: "/admin/contact/audience/details",})
                        
                      } }
                      style={{}}
                      className="lg_btn tertiary "
                      value="Cancel"
                    />
                }
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  );
}
export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings width="100" />,
  });

  return (
    <section style={{ zIndex: "10" }} {...containerProps}>
      {indicatorEl}
    </section>
  );
}
export default CreateCampaign;
